<header class="flex-row-center py-2 px-3">
  <div class="absolute md:hidden me-3 cursor-pointer px-3" (click)="openMobileMenu()">
    <fa-icon [icon]="faBars" />
  </div>

  <div class="flex-1 text-center md:text-start">
    <div class="inline-block cursor-pointer" [routerLink]="RouteLocations.Dashboard.absoluteUrl">
      <app-logo class="inline-block" [priority]="true" />
    </div>
  </div>

  <div class="hidden md:flex flex-row items-center">
    <a mat-button [href]="discordLink" target="_blank" class="ms-2">
      <fa-icon [icon]="faDiscord" size="lg" class="me-2" />
      Join community
    </a>

    <a mat-button [href]="patreonLink" target="_blank" class="ms-2">
      <fa-icon [icon]="faPatreon" size="lg" class="me-2" />
      Support on Patreon
    </a>

    <app-user-menu class="ms-3" />
  </div>
</header>
